import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';

function Cricket(){
  const [isLoading, setIsLoading] = useState(false);
      const [isLoggedIn] = useState(!!localStorage.getItem('token'));
      const navigate = useNavigate();
      const [error, setError] = useState(null);
      const origin = window.location.origin;

      // 9wickets link loaded from API, fallback to /9wiket
      const [nineWiketLink, setNineWiketLink] = useState('/9wiket');

      useEffect(() => {
        const fetchSportsList = async () => {
          try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/sports-list`);
            if (response.ok) {
              const data = await response.json();
              if (Array.isArray(data)) {
                const nineWkt = data.find(s =>
                  s.name?.toLowerCase().includes('9wicket') ||
                  s.link === '/9wiket'
                );
                if (nineWkt?.link) {
                  setNineWiketLink(nineWkt.link);
                }
              }
            }
          } catch (err) {
            // keep default /9wiket link on error
          }
        };
        fetchSportsList();
      }, []);
  
  
      const handleGameClicks = async (gameCode, gamePlatform, gameType) => {
       
        if (!isLoggedIn) {
            navigate('/login');
            return;
        }
    
        const token = localStorage.getItem('token');
        const remote_id = localStorage.getItem('remote_id');
    
        if (!token || !remote_id) {
            setError('User not logged in');
            return;
        }
    
        setIsLoading(true);
    
        try {
            if (gamePlatform === 'Lucky') {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/api/player-login`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        user_id: remote_id,
                    }),
                });
    
                const dataly = await response.json();
                console.log(`https://sprodm.uni247.xyz/?access_token=${dataly.access_token}`);
                navigate('/gamerun', {
                    state: {
                        iframeUrl: `https://sprodm.uni247.xyz/?access_token=${dataly.access_token}`,
                    },
                });
    
                return; 
            }
    
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/inr-game-run`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                body: JSON.stringify({
                    userId: remote_id,
                    externalURL: origin,
                isMobileLogin: window.innerWidth <= 768,
                    gameCode: gameCode,
                    gameType: gameType,
                    platform: gamePlatform,
                }),
            });
    
            const data = await response.json();
    
            if (response.ok) {
              const iframeUrl = data?.url || data?.data?.payload?.game_launch_url;
              if (iframeUrl) {
                navigate('/gamerun', { state: { iframeUrl } });
              } else {
                setError(data.message || 'Missing game URL in response');
              }
            } else {
                setError(data.message || 'An unexpected error occurred');
            }
        } catch (error) {
            setError('An unexpected error occurred');
        } finally {
            setIsLoading(false);
        }
    };

    const handleExchangeClick = () => {
  navigate('/exchange');
};

  const handleNineWiketClick = () => {
    if (!isLoggedIn) {
      navigate('/login');
      return;
    }
    navigate(nineWiketLink);
  };

  return (
    <div className="row mt-0 hidden-md-and-up mobile-provider-card-row" style={{paddingBottom: '10px'}}>
  <div className="mobile-provider-card-item col gT_cricket" onClick={handleNineWiketClick}>
    <div className="v-image v-responsive banner-img theme--dark">
      <div className="v-responsive__sizer" style={{paddingBottom: '33.3333%'}} />
      <div className="v-image__image v-image__image--contain" style={{backgroundImage: 'url("./banner/9wickets.png"), url("./banner/exchnage.webp")', backgroundPosition: 'center center', backgroundSize: 'cover'}} />
      <div className="v-responsive__content">
        <img src="./static/image/other/hot-icon.png" className="img-hot-home pos_right_top" />
      </div>
    </div>
  </div>
  <div className="mobile-provider-card-item col gT_cricket" onClick={() => handleGameClicks('E1-ESPORTS-001', 'E1SPORT', 'ESPORTS')}>
    <div className="v-image v-responsive banner-img theme--dark">
      <div className="v-responsive__sizer" style={{paddingBottom: '33.3333%'}} />
      <div className="v-image__image v-image__image--contain" style={{backgroundImage: 'url("./banner/e1sports.avif")', backgroundPosition: 'center center', backgroundSize: 'cover'}} />
      <div className="v-responsive__content">
        <img src="./static/image/other/hot-icon.png" className="img-hot-home pos_right_top" />
      </div>
    </div>
  </div>
  <div className="mobile-provider-card-item col gT_cricket" onClick={() => handleGameClicks('PINNACLE-SPORTS-001', 'PINNACLE', 'SPORTS')}>
    <div className="v-image v-responsive banner-img theme--dark">
      <div className="v-responsive__sizer" style={{paddingBottom: '33.3333%'}} />
      <div className="v-image__image v-image__image--contain" style={{backgroundImage: 'url("./banner/PINNACLE.png")', backgroundPosition: 'center center', backgroundSize: 'cover'}} />
      <div className="v-responsive__content">
        <img src="./static/image/other/hot-icon.png" className="img-hot-home pos_right_top" />
      </div>
    </div>
  </div>
   <div className="mobile-provider-card-item col gT_cricket" onClick={() => handleGameClicks('HRB-LIVE-001', 'HORSEBOOK', 'LIVE')}>
    <div className="v-image v-responsive banner-img theme--dark">
      <div className="v-responsive__sizer" style={{paddingBottom: '33.3333%'}} />
      <div className="v-image__image v-image__image--contain" style={{backgroundImage: 'url("./banner/HORSEBOOK.jpg")', backgroundPosition: 'center center', backgroundSize: 'cover'}} />
      <div className="v-responsive__content">
        <img src="./static/image/other/hot-icon.png" className="img-hot-home pos_right_top" />
      </div>
    </div>
  </div>
   <div className="mobile-provider-card-item col gT_cricket" onClick={() => handleGameClicks('SABA-VIRTUAL-001', 'SABA', 'VIRTUAL')}>
    <div className="v-image v-responsive banner-img theme--dark">
      <div className="v-responsive__sizer" style={{paddingBottom: '33.3333%'}} />
      <div className="v-image__image v-image__image--contain" style={{backgroundImage: 'url("./banner/saba.jpg")', backgroundPosition: 'center center', backgroundSize: 'cover'}} />
      <div className="v-responsive__content">
        <img src="./static/image/other/hot-icon.png" className="img-hot-home pos_right_top" />
      </div>
    </div>
  </div>
  <div className="mobile-provider-card-item col gT_cricket" onClick={() => handleGameClicks('Lucky', 'Lucky', 'Lucky')}>
    <div className="v-image v-responsive banner-img theme--dark">
      <div className="v-responsive__sizer" style={{paddingBottom: '33.3333%'}} />
      <div className="v-image__image v-image__image--contain" style={{backgroundImage: 'url("./banner/lucky.png")', backgroundPosition: 'center center', backgroundSize: 'cover'}} />
      <div className="v-responsive__content">
        <img src="./static/image/other/hot-icon.png" className="img-hot-home pos_right_top" />
      </div>
    </div>
  </div>
 
</div>

  );
}
export default Cricket;